
import { mapState, mapMutations } from 'vuex'
import Search from 'vux/src/components/search/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'

import { searchGoods } from '@/service/index'
import { saveSearch, getSearchInfo } from '@/utils/cache'
export default {
components:{
Search, Grid, GridItem, GroupTitle, CellBox
},
data(){
return {
keyword: "",
hot: [],
searchResult: [],
}
},
mounted(){
this.$refs.searchPage.setFocus();
this.hot = getSearchInfo()
if(this.$route.query.keyword){
this.keyword = this.$route.query.keyword
this.doSearch()
}
},
computed: {
...mapState([
'campaign'
]),
showHistory(){
return this.searchResult.length > 0
}
},
watch:{
keyword(newValue){
this.doSearch(newValue)
}
},
methods: {
...mapMutations({
initGoods: 'INIT_GOODS'
}),
goBack(){
this.$router.push({
path: `/home/${this.$route.query.cid}`,
query: { cid: this.$route.query.cid, keyword: this.keyword }
})
},
async doSearch(){
if(this.keyword){
const res = await searchGoods(this.$route.query.cid, {
keyword: this.keyword
});
if(res.status === 0){
this.searchResult = res.data;
}
}else{
this.clearSearch()
}
},
clearSearch(){
this.searchResult = []
},
saveThisHistory(item){
saveSearch(this.keyword)
this.$router.push({
path: '/detailMb',
query: {
id: item.id,
cid: this.$route.query.cid
}
})
},
selectKey(key){
this.keyword = key
},
goHome(){
saveSearch(this.keyword)
this.$router.push({
path: `/home/${this.$route.query.cid}`,
query: { cid: this.$route.query.cid, keyword: this.keyword }
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/home/Search.vue